const headCellsListBranch = [
    { id: 'name', numeric: false, disablePadding: true, label: 'Tên chi hội' },
    { id: 'description', numeric: false, disablePadding: false, label: 'Mô tả' },
    { id: 'isActived', numeric: false, disablePadding: false, label: 'Trạng thái', align: 'center' },
    { id: 'action', numeric: false, disablePadding: false, label: 'Thao tác' },
];

export default headCellsListBranch;
